import GradesVM from './grades-vm';
import SummaryVM from './summary-vm';
import AnalyticsVM from './analytics-vm';
export default function() {
  var self = this;
  self.tabVMs = {
    GradesVM,
    SummaryVM,
    AnalyticsVM
  };
  self.student_id = ko.observable();
  self.activeTab = ko.observable();
  self.student = ko.observable();
  self.grades = null;
  self.summary = null;
  self.analytics = null;

  self.initUI = function() {

  };

  self.refreshURL = function () {
    if (self.student()) {
      var url = Kadenze.Routes.course_gradebook_student_path(self.course_id, self.student().slug(), {sheet: self.activeTab()});
      history.replaceState($.pjax.state, null, url);
    }
  };

  self.initStudentNav = function () {
    self.getStudent(self.student_id()).done(function (response) {
      var mapped_student = ko.mapping.fromJS(response.student);
      self.student(mapped_student);

      //Pre-fetch surrounding students
      self.getStudent(response.student.next_student_id);
      self.getStudent(response.student.prev_student_id);
    });
  };

  self.getStudent = _.memoize(function (student_id) {
    return new Kadenze.AjaxRequest({
      type: 'GET',
      url: Kadenze.Routes.show_course_gradebook_students_path(self.course_id, {student_id: student_id})
    });
  });

  self.initSpreadsheet = function() {
    var tab = self.activeTab();
    if (_.includes(['grades', 'summary', 'analytics'], tab)) {
      if (self[tab] == null) {
        var vmName = s.capitalize(tab) + 'VM';
        var vm = self.tabVMs[vmName];
        self[tab] = new vm(self.student_id());
        ko.applyBindingsWithValidation(self[tab], self[tab].$el[0], Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
      } else if (self[tab].student_id() != self.student_id()) {
        self[tab].student_id(self.student_id());
      }
      self.refreshURL();
    }
  };

  self.showStudent = function (student_id) {
    if (!isNaN(parseInt(student_id))) {
      self.student_id(student_id);
    }
  };

  self.showTab = function (tab) {
    self.activeTab(tab);
    var tabId = '#{name}-tab'.supplant({name: tab});
    var $el = $(tabId);
    $el.tab('show');
  };

  self.activeVM = function () {
    return self[self.activeTab()];
  };

  self.exportTable = function (item, event) {
    var vm = self.activeVM();
    vm && vm.exportTable();
    event.stopPropagation();
  };

  const __construct = function(that) {
    console.log('constructor called for InstructorGradebook.Student.OverviewVM');
    that.course_id = $('#course_id').val();

    //Update student nav and spreadsheet if student changes
    that.student_id($('#student_id').val());
    that.student_id.subscribe(that.initStudentNav);
    that.student_id.subscribe(that.initSpreadsheet);

    that.initStudentNav();

    //Update spreadsheet if active sheet changes
    var sheet = Kadenze.Util.getParameterByName('sheet');
    that.activeTab.subscribe(that.initSpreadsheet);
    that.showTab(sheet || 'grades');
  }(this);
}

